// 상품 찾기 목록의 기본 페이지 크기
export const SEARCH_PRODUCTS_DEFAULT_PAGE_SIZE = 50;

// 즐겨찾기 브랜드 상한 — 서버에 개수 제한이 없어 프런트에서 둔다.
// 관리 모달과 카드 별 토글이 같은 값을 써야 규칙이 어긋나지 않는다.
export const MAX_FAVORITE_BRANDS = 10;
